module.exports = __webpack_public_path__ + "static/img/SV@3x.d4861b26.png";